import { Box, styled, Switch, Typography } from '@mui/material';

const useStyles = () => ({
  blueText: {
    color: '#3171F6',
    fontWeight: 700,
    fontSize: '14px',
    mb: "8px",
  },
  text: {
    color: '#1F1F1F',
    fontWeight: 700,
    fontSize: '12px',
  },
});

function PlanToggle(props) {
  const { value, setter, containerProps = {} } = props;

  const classes = useStyles();

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    margin: '0 6px',
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#1890ff',
          // ...theme.applyStyles('dark', {
          //   backgroundColor: '#177ddc',
          // }),
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      // transition: theme.transitions.create(['width'], {
      //   duration: 200,
      // }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: 'black',
      boxSizing: 'border-box',
      // ...theme.applyStyles('dark', {
      //   backgroundColor: 'rgba(255,255,255,.35)',
      // }),
    },
  }));

  return (
    <Box {...containerProps}>
      <Typography sx={classes.blueText}>Go annual and save!</Typography>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography sx={classes.text}>Monthly</Typography>
        <AntSwitch checked={value} onChange={(e, value) => setter(value)} />
        <Typography sx={classes.text}>Annual</Typography>
      </Box>
    </Box>
  );
}

export default PlanToggle;
